import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useContext } from "react";
import ExpandCollapseIcon from "src/components/icons/purposed/ExpandCollapseIcon";
import GridKeikka_NewKeikka_BetoniAsiakasSelector from "../components/GridKeikka_NewKeikka_BetoniAsiakasSelector";
import GridKeikka_NewKeikka_PumppuAsiakasSelector from "../components/GridKeikka_NewKeikka_PumppuAsiakasSelector";
import MyDivider2 from "src/components/layout/MyDivider2";
import GridKeikka_NewKeikka_LaskutusSelector from "../components/GridKeikka_NewKeikka_LaskutusSelector";
import { GridKeikka_NewKeikkaContext } from "src/context/GridKeikka_NewKeikkaContext";
import GridKeikka_NewKeikka_SourceAsiakasSelector from "../components/GridKeikka_NewKeikka_SourceAsiakasSelector";
import { AsetuksetIcon } from "src/components/icons/StepIcons";

export default function GridKeikka_NewKeikkaLayout_Accordion({
  onAddNewAsiakasClicked,
  onEditSourceClick,
}) {
  const { accordionExpanded, setAccordtionExpanded } = useContext(GridKeikka_NewKeikkaContext);

  return (
    <Accordion
      expanded={accordionExpanded}
      onChange={() => setAccordtionExpanded(!accordionExpanded)}>
      <AccordionSummary
        expandIcon={<ExpandCollapseIcon />}
        aria-controls="asiakasAjoneuvotList-content"
        id="asiakasAjoneuvotList-header">
        <div className="center" style={{ gap: 4 }}>
          <AsetuksetIcon color="secondary" />{" "}
          <Typography color="secondary" variant="body2">
            {accordionExpanded ? "Piilota " : "Näytä "} edistykselliset toiminnot
          </Typography>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <GridKeikka_NewKeikka_SourceAsiakasSelector onAddClick={onEditSourceClick} />
        <div className="newKeikka_selectors">
          <GridKeikka_NewKeikka_BetoniAsiakasSelector onAddClick={onAddNewAsiakasClicked} />
          <MyDivider2 rows={2} height={3} />
          <GridKeikka_NewKeikka_PumppuAsiakasSelector onAddClick={onAddNewAsiakasClicked} />
        </div>
        <GridKeikka_NewKeikka_LaskutusSelector />
      </AccordionDetails>
    </Accordion>
  );
}

GridKeikka_NewKeikkaLayout_Accordion.propTypes = {
  onAddNewAsiakasClicked: PropTypes.func.isRequired,
  onEditSourceClick: PropTypes.func.isRequired,
};
